(() => {
  'use strict';
  if (window.AWModelStatusUI?.version) return;

  const VERSION = '1.0.0';
  const KEYS = {
    replicas: 'aw_garage_replicas_v1',
    saved: 'aw_airsoft_saved_configurations',
    modelMap: 'aw_saved_config_models_v1'
  };

  const normalize = (value = '') => String(value)
    .replace(/[₂²]/g, '2').replace(/[₀⁰]/g, '0')
    .trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' et ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const readJson = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return fallback; }
  };

  const canonicalModels = () => {
    const map = new Map();
    document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]').forEach((node) => {
      const handle = String(node.dataset.handle || '').trim();
      if (!handle || map.has(normalize(handle))) return;
      map.set(normalize(handle), {
        handle,
        label: String(node.dataset.label || node.dataset.model || handle).trim(),
        model: String(node.dataset.model || '').trim(),
        manufacturer: String(node.dataset.manufacturer || '').trim(),
        platform: String(node.dataset.platform || '').trim(),
        type: String(node.dataset.type || '').trim(),
        pageUrl: String(node.dataset.pageUrl || '').trim()
      });
    });
    return map;
  };

  const compatibilityUrl = () => {
    const link = document.querySelector('.aw14-nav__link[href*="compatibilite-airsoft"]');
    return link?.getAttribute('href') || '/pages/compatibilite-airsoft';
  };

  const ensureResolution = (card) => {
    let node = card.querySelector('[data-aw-model-resolution]');
    if (node) return node;
    node = document.createElement('div');
    node.className = 'aw-model-resolution';
    node.dataset.awModelResolution = 'true';
    const top = card.querySelector('.aw-p2-card__top');
    if (top) top.insertAdjacentElement('afterend', node);
    else card.prepend(node);
    return node;
  };

  const garageResolution = (replica) => {
    if (!replica) return { status: 'none', label: '', pageUrl: '' };
    const bridge = window.AWModelContextBridge;
    const canonical = typeof bridge?.resolveReplica === 'function' ? bridge.resolveReplica(replica) : null;
    if (canonical?.handle) {
      return {
        status: 'exact',
        label: String(canonical.label || canonical.model || replica.model || '').trim(),
        pageUrl: String(canonical.pageUrl || '').trim(),
        handle: String(canonical.handle || '').trim()
      };
    }
    if (String(replica.model || '').trim()) {
      return { status: 'review', label: String(replica.model).trim(), pageUrl: '', handle: '' };
    }
    return { status: 'none', label: '', pageUrl: '', handle: '' };
  };

  const renderGarageResolution = (card, replica, resolution) => {
    const node = ensureResolution(card);
    const signature = [resolution.status, resolution.handle, resolution.label].join('|');
    if (node.dataset.awSignature === signature) return;
    node.dataset.awSignature = signature;
    node.className = `aw-model-resolution is-${resolution.status}`;
    card.dataset.awModelResolutionStatus = resolution.status;
    if (resolution.handle) card.dataset.awExactModel = resolution.handle;
    else delete card.dataset.awExactModel;

    node.replaceChildren();
    const badge = document.createElement('span');
    badge.className = 'aw-model-resolution__badge';
    const copy = document.createElement('span');
    copy.className = 'aw-model-resolution__copy';
    const strong = document.createElement('strong');
    const small = document.createElement('small');

    if (resolution.status === 'exact') {
      badge.textContent = 'Modèle AW exact';
      strong.textContent = resolution.label || 'Modèle exact identifié';
      small.textContent = 'Correspondance univoque avec une fiche modèle Compatibility AW.';
    } else if (resolution.status === 'review') {
      badge.textContent = 'Modèle Garage — à vérifier';
      strong.textContent = resolution.label || 'Modèle saisi dans Garage';
      small.textContent = 'Ce texte Garage n’est pas encore relié de façon univoque à une fiche modèle AW.';
    } else {
      badge.textContent = 'Modèle non renseigné';
      strong.textContent = 'Plateforme seulement';
      small.textContent = 'Ajoutez le modèle exact pour permettre une résolution Compatibility AW.';
    }

    copy.append(strong, small);
    node.append(badge, copy);

    const link = document.createElement('a');
    link.className = 'aw-model-resolution__link';
    link.href = resolution.status === 'exact' && resolution.pageUrl ? resolution.pageUrl : compatibilityUrl();
    link.textContent = resolution.status === 'exact' ? 'Voir Compatibility' : 'Identifier le modèle';
    node.append(link);
  };

  const decorateGarage = () => {
    const root = document.querySelector('[data-aw-garage-p2]');
    if (!root) return;
    const replicas = readJson(KEYS.replicas, []);
    if (!Array.isArray(replicas)) return;
    root.querySelectorAll('[data-replica-id]').forEach((card) => {
      const replica = replicas.find((item) => String(item?.id || '') === String(card.dataset.replicaId || ''));
      if (!replica) return;
      renderGarageResolution(card, replica, garageResolution(replica));
    });
  };

  const ensureProjectStatus = (card) => {
    let node = card.querySelector('[data-aw-project-model-status]');
    if (node) return node;
    node = document.createElement('div');
    node.className = 'aw-project-model-status';
    node.dataset.awProjectModelStatus = 'true';
    const header = card.querySelector('.aw-atelier__project-header');
    if (header) header.insertAdjacentElement('afterend', node);
    else card.prepend(node);
    return node;
  };

  const projectModelHandle = (card) => {
    if (card.dataset.awExactModel) return String(card.dataset.awExactModel);
    const link = card.querySelector('.aw-atelier__project-actions a[href*="configurateur-airsoft"]');
    if (!link) return '';
    try { return new URL(link.href, location.origin).searchParams.get('aw_model') || ''; }
    catch (_) { return ''; }
  };

  const decorateProjects = () => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return;
    const models = canonicalModels();
    root.querySelectorAll('[data-aw-project]').forEach((card) => {
      const handle = projectModelHandle(card);
      const model = handle ? models.get(normalize(handle)) : null;
      const node = ensureProjectStatus(card);
      const signature = model ? `exact|${model.handle}|${model.label}` : 'platform-only';
      if (node.dataset.awSignature === signature) return;
      node.dataset.awSignature = signature;
      node.replaceChildren();

      const badge = document.createElement('span');
      badge.className = 'aw-project-model-status__badge';
      const copy = document.createElement('span');
      copy.className = 'aw-project-model-status__copy';

      if (model) {
        node.className = 'aw-project-model-status is-exact';
        card.dataset.awModelResolutionStatus = 'exact';
        badge.textContent = 'Réplique exacte';
        copy.textContent = model.label || model.model || model.handle;
      } else {
        node.className = 'aw-project-model-status is-platform';
        card.dataset.awModelResolutionStatus = 'platform';
        badge.textContent = 'Plateforme uniquement';
        copy.textContent = 'Modèle exact non lié';
      }
      node.append(badge, copy);
    });
  };

  const decorateHistory = () => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return;
    root.querySelectorAll('[data-aw-shopify-order-item]').forEach((item) => {
      const status = String(item.dataset.modelStatus || '').trim();
      if (!status) return;
      item.dataset.awModelResolutionStatus = status === 'exact' ? 'exact' : 'review';
    });
  };

  let scheduled = false;
  const refresh = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      decorateGarage();
      decorateProjects();
      decorateHistory();
    });
  };

  const observe = (root) => {
    if (!root || root.dataset.awModelStatusObserved === 'true' || !('MutationObserver' in window)) return;
    root.dataset.awModelStatusObserved = 'true';
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-aw-exact-model'] });
  };

  const install = () => {
    observe(document.querySelector('[data-aw-garage-p2]'));
    observe(document.querySelector('[data-aw-atelier]'));
    refresh();
  };

  window.addEventListener('aw:p2-garage-updated', refresh);
  window.addEventListener('aw:context-changed', refresh);
  window.addEventListener('storage', (event) => {
    if ([KEYS.replicas, KEYS.saved, KEYS.modelMap].includes(event.key)) refresh();
  });
  document.addEventListener('shopify:section:load', install);

  window.AWModelStatusUI = { version: VERSION, refresh, garageResolution };
  install();
  [50, 250, 1000, 2000].forEach((delay) => window.setTimeout(install, delay));
})();